var _desc, _defs, _rect, _text, _text2, _rect2, _text3, _text4, _text5, _text6, _rect3, _text7, _path, _rect4, _text8, _text9, _path2, _rect5, _text0, _path3, _rect6, _text1, _text10, _path4, _text11, _rect7, _text12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcsFargateArchitecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 1120",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "ECS Fargate \uBC30\uD3EC\xB7\uD2B8\uB798\uD53D\xB7\uB85C\uADF8 \uC544\uD0A4\uD14D\uCC98") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Terraform\uC73C\uB85C \uAD00\uB9AC\uD558\uB294 \uC778\uD504\uB77C \uAC1C\uB150\uB3C4. GitHub Actions\uC640 Jenkins\uC758 \uBC30\uD3EC \uACBD\uB85C \uBC0F ECR \uC774\uBBF8\uC9C0\uAC00 ECS Fargate\uB85C \uC5F0\uACB0\uB41C\uB2E4. Route53\uACFC Public\xB7Internal ALB, \uC11C\uBE44\uC2A4\uBCC4 Target Group\uC744 \uAC70\uCCD0 \uD2B8\uB798\uD53D\uC744 \uCC98\uB9AC\uD558\uBA70 \uBE14\uB8E8\xB7\uADF8\uB9B0 \uBC30\uD3EC, \uB864\uBC31, Task Auto Scaling\uACFC FireLens \uB85C\uADF8 \uB77C\uC6B0\uD305\uC744 \uAD6C\uC131\uD55C\uB2E4. \uC2E4\uC81C \uC11C\uBE44\uC2A4 \uC218\uC640 \uB124\uD2B8\uC6CC\uD06C \uBC30\uCE58\uB294 \uC0DD\uB7B5\uD588\uB2E4.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L10 5L0 10Z",
    fill: "#1377ad"
  })), /*#__PURE__*/React.createElement("style", null, "\n      text { font-family: Pretendard, \"Apple SD Gothic Neo\", \"Noto Sans KR\", sans-serif; }\n      .title { font-size: 48px; font-weight: 800; fill: #26384b; }\n      .label { font-size: 44px; font-weight: 750; fill: #26384b; }\n      .caption { font-size: 36px; font-weight: 600; fill: #506174; }\n      .accent { fill: #1377ad; }\n      .arrow { fill: none; stroke: #1377ad; stroke-width: 4; marker-end: url(#arrow); }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 1120,
    rx: 38,
    fill: "#fbfcfd"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    className: "title"
  }, "ECS Fargate \uC6B4\uC601 \uAD6C\uC870")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 126,
    className: "caption"
  }, "Terraform \uAD00\uB9AC \xB7 \uAD6C\uC131 \uAC1C\uB150\uB3C4")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 166,
    width: 864,
    height: 174,
    rx: 24,
    fill: "#f1f5f8"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 216,
    className: "caption"
  }, "\uBC30\uD3EC \uACBD\uB85C")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 270,
    className: "label"
  }, "GitHub Actions / Jenkins")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 318,
    className: "caption"
  }, "ECR \uC774\uBBF8\uC9C0 \u2192 Fargate \uBC30\uD3EC")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 408,
    className: "caption accent"
  }, "\uC694\uCCAD \uD750\uB984 \xB7 Public / Internal \uACBD\uACC4 \uC720\uC9C0")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 442,
    width: 256,
    height: 130,
    rx: 20,
    fill: "#eef8fd",
    stroke: "#dce4ea",
    strokeWidth: 2
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 176,
    y: 524,
    textAnchor: "middle",
    className: "label"
  }, "Route53")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M308 507H374",
    className: "arrow"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 394,
    y: 442,
    width: 518,
    height: 130,
    rx: 20,
    fill: "#eef8fd",
    stroke: "#dce4ea",
    strokeWidth: 2
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 653,
    y: 498,
    textAnchor: "middle",
    className: "label"
  }, "ALB \xB7 12\uAC1C \u2192 4\uAC1C")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 653,
    y: 548,
    textAnchor: "middle",
    className: "caption"
  }, "Public / Internal")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M653 576V626",
    className: "arrow"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 642,
    width: 864,
    height: 100,
    rx: 20,
    fill: "#eef8fd",
    stroke: "#dce4ea",
    strokeWidth: 2
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 707,
    textAnchor: "middle",
    className: "label"
  }, "\uC11C\uBE44\uC2A4\uBCC4 Target Group")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M480 746V796",
    className: "arrow"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 812,
    width: 864,
    height: 150,
    rx: 24,
    fill: "#eaf6fc",
    stroke: "#dce4ea",
    strokeWidth: 2
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 869,
    textAnchor: "middle",
    className: "label accent"
  }, "ECS Fargate \xB7 Task")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 927,
    textAnchor: "middle",
    className: "caption"
  }, "\uBE14\uB8E8/\uADF8\uB9B0 \uBC30\uD3EC \xB7 \uB864\uBC31 \xB7 Auto Scaling")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M480 966V1010",
    className: "arrow"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 1005,
    className: "caption"
  }, "\uB85C\uADF8")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 1026,
    width: 864,
    height: 62,
    rx: 18,
    fill: "#f1f5f8"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 1070,
    textAnchor: "middle",
    className: "caption"
  }, "FireLens \xB7 \uB85C\uADF8 \uB77C\uC6B0\uD305")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcsFargateArchitecture);
export default __webpack_public_path__ + "static/media/ecs-fargate-architecture.22ef997530b9287f499ba0f7f03cdec9.svg";
export { ForwardRef as ReactComponent };